import {
  FEATURE_KEYS,
  useFeatureFlags,
} from '../../contexts/FeatureFlagsContext';
import OnboardingInfoBox from './OnboardingInfoBox';

const OnboardingEtfNotice = () => {
  const { flags, loaded } = useFeatureFlags();
  const showNotice =
    loaded && flags[FEATURE_KEYS.onboardingEtfFundNotice] === true;

  if (!showNotice) {
    return null;
  }

  return (
    <OnboardingInfoBox variant="etf" title="Coming soon: invest in our fund directly">
      <p>
        Once NovaQuantis issues its own ETF fund, this process of connecting a brokerage
        account will no longer be necessary. Our customers will be able to invest
        directly in the fund through NovaQuantis.
      </p>
    </OnboardingInfoBox>
  );
};

export default OnboardingEtfNotice;
